import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import LargeDisplayBox from '@client/components/largeDisplayBox/LargeDisplayBox';
import SectionTitle from '@client/components/texts/SectionTitle';
import { strings } from '@client/localization/Localization';
import { ROUTES, seriesRoute } from '@client/pages/routes';
import { COLORS } from '@client/shared/js/Colors';
import themeStyles from '@client/shared/styles/theme/theme-styles.scss';
import 'react-dynamic-swiper/lib/styles.css';
import indicators from '@client/shared/js/indicators';
import shapes from '@client/shared/js/shapes';
import styles from './featuredSeriesSection.scss';

class FeaturedSeriesSection extends PureComponent {
  navigateTo = (link) => {
    this.props.history.push(link);
  };

  render() {
    const {
      className,
      series = [],
      sectionTitle,
      titleColor,
      linkTextNotActive,
    } = this.props;

    if (series.length === 0) {
      return null;
    }

    return (
      <div
        className={
          className
            ? `${styles.featuredSeriesSection} ${className}`
            : styles.featuredSeriesSection
        }
      >
        <div className={styles.allSeriesContainer}>
          <div className={styles.contentContainer}>
            <SectionTitle
              title={sectionTitle}
              className={`${styles.sectionTitle} ${themeStyles.featuredSeriesTitle}`}
              linkText={strings.allSeries}
              linkTextNotActive={linkTextNotActive}
              linkColor={COLORS.colorBrandDarkGrey}
              onLinkClick={() => this.navigateTo(ROUTES.series)}
              titleColor={titleColor || COLORS.colorBrandGreen}
              icon={indicators.arrow_purple}
            />
            <div className={styles.gridContainer}>
              {series.map((item, index) => {
                return (
                  <div key={index} className={styles.gridElement}>
                    <LargeDisplayBox
                      title={item.title}
                      description={item.description}
                      imgSrc={item.thumbnailImageUrl}
                      alt={item.title}
                      buttonText={strings.watchTheSeries}
                      sponsor={item.sponsor ? item.sponsor : undefined}
                      route={seriesRoute(item.slug)}
                      numOfEpisodes={item.episodeCount}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className={styles.shapeTopRight}>
          <picture>
            <source
              media="(max-width: 768px)"
              srcSet={shapes.graphic_footer_mobile_x2}
            />
            <img
              className={styles.shapeTopRight}
              src={shapes.graphic_footer_x2}
              alt="Factuals graphic footer"
            />
          </picture>
        </div>
      </div>
    );
  }
}

FeaturedSeriesSection.propTypes = {
  className: PropTypes.string,
  sectionTitle: PropTypes.string,
  titleColor: PropTypes.string,
  series: PropTypes.array,
  history: PropTypes.object,
  linkTextNotActive: PropTypes.bool,
};

export default withRouter(FeaturedSeriesSection);
